/* Yatu Kids — kleine hulpjes voor het thema */
(function () {
  'use strict';

  /* mobiel menu open/dicht */
  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-menu-knop]');
    if (!knop) return;
    var menu = document.getElementById('mobielmenu');
    if (menu) menu.classList.toggle('open');
  });

  /* productfoto's wisselen */
  document.addEventListener('click', function (e) {
    var mini = e.target.closest('[data-mini]');
    if (!mini) return;
    var groot = document.getElementById('product-foto');
    if (groot) groot.src = mini.dataset.groot || mini.src;
  });

  /* winkelwagen-teller bijwerken na toevoegen via JS */
  window.yatuUpdateCart = function () {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  };
})();
